import React from 'react'
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import QuizRoundedIcon from '@mui/icons-material/QuizRounded';
import FilterTiltShiftOutlinedIcon from '@mui/icons-material/FilterTiltShiftOutlined';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import * as Unicons from '@iconscout/react-unicons';


export const accountPageData = [
    {
      id: 1,
      title: "YOUR ORDERS",
      icon: <Unicons.UilPackage size='25' className='d_d_m_icons'/>,
      path: "./account/your-orders",
      cName: "acc_nav_link",
    },
    {
      id: 2,
      title: "ACCOUNT",
      icon: <FavoriteBorderRoundedIcon fontSize='small' className='d_d_m_icons'/>,
      path: "./account/your-wishlist",
      cName: "acc_nav_link",
    },
    {
      id: 3,
      title: "PAYMENTS",
      icon: <NotificationsNoneRoundedIcon fontSize='small' className='d_d_m_icons'/>,
      path: "./account/notifications",
      cName: "acc_nav_link",
    },
    {
      id: 4,
      title: "CREDITS",
      icon: <QuizRoundedIcon fontSize='small' className='d_d_m_icons'/>,
      path: "./account/frequently-asked-questions",
      cName: "acc_nav_link",
    },
    {
      id: 5,
      title: "Utkarshita Stories",
      icon: <FilterTiltShiftOutlinedIcon fontSize='small' className='d_d_m_icons'/>,
      path: "./account/stories",
      cName: "acc_nav_link",
    },
    {
      id: 6,
      title: "Coupons",
      icon: <LocalActivityOutlinedIcon fontSize='small' className='d_d_m_icons'/>,
      path: "./account/rewards",
      cName: "acc_nav_link",
    },
  ];